import { FunctionComponent } from 'react';
import { DraftDesignConfiguration } from '@/types';
import { RendererProps } from '../ConfigurationRenderer';
import { useDesign } from './useDesign';

export const DesignReadOnlyRenderer: FunctionComponent<RendererProps<DraftDesignConfiguration>> = ({
  configuration,
}) => {
  const [designElement, transform] = useDesign(configuration);

  return <g transform={transform}>{designElement}</g>;
};
